<template>
  <div id="critical_edition">
    <div class="container">
      <div class="form-group row">
        <label class="col-sm-2 col-form-label"><b>Obra:</b></label>
        <div class="input-group col">
          <select @change="selectDocument({code: $event.target.value})"
                  :value="document && document.code" class="form-control">
            <option value="">Elija una obra</option>
            <option v-for="(title, code) in documents" :value="code">{{ title }}</option>
          </select>
          <div class="input-group-append">
            <a v-if="document" :href="pdfPath" target="_blank" class="btn btn-primary">
              <i class="fa fa-download"></i>
            </a>
          </div>
        </div>
      </div>
    </div>
    <div v-if="document" class="panels row m-3">
      <div class="left col-xl-6">
        <panel ref="left" side="left"/>
      </div>
      <div class="right col-xl-6">
        <panel ref="right" side="right"/>
      </div>
    </div>
    <div v-else-if="!document && isPending" class="d-flex justify-content-center mt-5">
      <i class="fa fa-spinner fa-spin fa-5x"></i>
    </div>
  </div>
</template>
<script>
  import qs from 'qs'
  import {mapState, mapActions} from 'vuex'
  import EditionPanel from './EditionPanel'
  import BaseEditionPanel from './BaseEditionPanel'
  import Panel from './Panel'

  export default {
    components: {Panel, EditionPanel, BaseEditionPanel},
    mounted() {
      const {document: code, start} = qs.parse(window.location.search.substr(1))
      if (code) this.selectDocument({code, start: Number(start || 1)})
    },
    computed: {
      ...mapState({
        documents: s => s.documents,
        document: s => s.document,
        isPending: s => s.status === 'pending'
      }),
      pdfPath() {
        return this.document ? `./editions/${this.document.code}.pdf` : null
      }
    },
    methods: {
      ...mapActions(['selectDocument']),
    }
  }
</script>
